const PERCENTAGE_THRESHOLD = 100;

export const isValidDeal = ({ itinerary, dealPrice }) => {
  const { price } = itinerary;

  if (!price?.amount || !dealPrice) return false;

  const threshold = (dealPrice * PERCENTAGE_THRESHOLD) / 100;

  return price.amount < dealPrice + threshold;
};
